import LinkToDocusaurus from '../LinkToDocusaurus'
import { gitIntegration } from '../../docs-routes'

const LinkToGitConnectionsDoc = () =>
  <LinkToDocusaurus path={gitIntegration}>
    Learn more about Git Connections
  </LinkToDocusaurus>

export default LinkToGitConnectionsDoc
